import { createSlice } from '@reduxjs/toolkit';

import {
  getLessonCategories,
  updateLessonCategoryById,
  removeLessonCategoryById,
} from './actions';

const initialState = {
  data: [] as any[],
  currentPage: 1,
  totalPages: null as any,
  perPage: 10,
};

const lessonCategoriesSlice = createSlice({
  name: 'lessonCategories',
  initialState,
  reducers: {},
  extraReducers: (builder: any) => {
    builder.addCase(getLessonCategories.fulfilled, (_: any, action: any) => {
      return action.payload;
    });

    builder.addCase(
      updateLessonCategoryById.fulfilled,
      (state: any, action: any) => {
        const { updatedCategory } = action.payload;

        return {
          ...state,
          data: state.data.map((category: any) => {
            if (category.id === updatedCategory.id) {
              return {
                ...category,
                ...updatedCategory,
              };
            }

            return category;
          }),
        };
      },
    );

    builder.addCase(
      removeLessonCategoryById.fulfilled,
      (state: any, action: any) => {
        return {
          ...state,
          data: state.data.filter(
            (category: any) => category.id !== action.payload,
          ),
        };
      },
    );
  },
});

export default lessonCategoriesSlice.reducer;
